import Session, { ALL_SUMMARY_PARAMS } from "services/Session";

export const priceUpdate = (relockData, loanInfo) => {
  Session.set(ALL_SUMMARY_PARAMS, {
    loanId: loanInfo?.loanId,
    programId: relockData.specificProgramID,
    rateDataId: relockData.specificRateDataID,
    effectiveDate: relockData.effectiveDate,
  });
};
